<template>
    <v-container fluid>
        <!--<DocumentClosed :document="document" v-on:clickOpen="open"></DocumentClosed>-->
        Document closed
        <v-dialog
                v-model="isExpanded"
                max-width="750px"
        >
            <!--<DocumentOpened :document="document" v-on:clickClose="close"></DocumentOpened>-->
            Document Opened
        </v-dialog>
    </v-container>
</template>

<script>

    export default {
        name: "Document",
        components: {
        },
        props: ["document"],
        data() {
            return {
                isExpanded: false
            }
        },
        computed: {   },
        created() { },
        methods: {
            open() {
                this.isExpanded = true;
            },
            close() {
                this.isExpanded = false;
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>
